// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"c10717d1","967":"8f08edda"}[chunkId] + ".chunk.js";
};